import React from 'react';
import styled from 'styled-components';

export const BackgroundImageContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const BackgroundImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
